import Main from "@/components/Main";

// desc：header的title
// isLogin: 是否是登录页
// type: 登录页类型

export default [{
    path: "/",
    name: "main",
    redirect: '/home',
    component: Main,
    children: [{
        path: 'home',
        name: 'home',
        meta: {
          title: '应用平台',
          desc: '应用平台',
          type: 'merchant'
        },
        component: () => import('@/views/home/home.vue')
      },{
        path: 'home-agent',
        name: 'homeAgent',
        meta: {
          title: '代理商平台',
          desc: '代理商平台',
          type: 'agent'
        },
        component: () => import('@/views/home/home-agent.vue')
      },{
        path: 'home-plat',
        name: 'homePlat',
        meta: {
          title: '平台端',
          desc: '平台端',
          type: 'plat'
        },
        component: () => import('@/views/home/home-plat.vue')
      },{
        path: 'agent-detail',
        name: 'agentDetail',
        meta: {
          title: '代理商详情',
          desc: '代理商详情',
          type: 'plat',
          showBack: true
        },
        component: () => import('@/views/home/agent-detail.vue')
      },
      {
        path: 'login',
        name: 'login',
        meta: {
          title: '登录',
          desc: '应用平台',
          isLogin: true,
          type: 'merchant'
        },
        component: () => import('@/views/login/login.vue')
      },
      {
        path: 'login-agent',
        name: 'loginAgent',
        meta: {
          title: '登录',
          desc: '代理商平台',
          isLogin: true,
          type: 'agent'
        },
        component: () => import('@/views/login/login-agent.vue')
      },
      {
        path: 'login-plat',
        name: 'loginPlat',
        meta: {
          title: '登录',
          desc: '平台端',
          isLogin: true,
          type: 'plat'
        },
        component: () => import('@/views/login/login-plat.vue')
      },
      {
        path: 'register',
        name: 'register',
        meta: {
          title: '注册',
          desc: '应用平台',
          isLogin: true,
          type: 'merchant'
        },
        component: () => import('@/views/login/register.vue')
      },
      {
        path: 'register-agent',
        name: 'registerAgent',
        meta: {
          title: '注册',
          desc: '代理商平台',
          isLogin: true,
          type: 'agent'
        },
        component: () => import('@/views/login/register-agent.vue')
      },
      {
        path: 'notice',
        name: 'notice',
        meta: {
          title: '通知中心',
          desc: '通知中心',
          showBack: true
        },
        component: () => import('@/views/notice/notice.vue')
      },
      {
        path: 'purchase',
        name: 'purchase',
        meta: {
          title: '购买服务',
          desc: '购买服务',
          miniLogo: true,
          type: 'merchant'
        },
        component: () => import('@/views/purchase/purchase.vue')
      },
      {
        path: 'help',
        name: 'help',
        meta: {
          title: '帮助中心',
          desc: '帮助中心',
          miniLogo: true,
          showSearch: true
        },
        component: () => import('@/views/help/help.vue')
      },
      {
        path: 'sub-app/*',
        name: 'subApp',
        meta: {
          title: '深度体验',
          desc: '',
          miniLogo: true,
          showBack: true,
          type: 'merchant'
        },
        component: () => import('@/views/sub-app/sub-app.vue')
      },
    ]
  },

  // {
  //   path: "/401",
  //   name: "error_401",
  //   meta: {
  //     hideInMenu: true
  //   },
  //   component: () => import("@/views/error-page/401.vue")
  // },
  // {
  //   path: "/500",
  //   name: "error_500",
  //   meta: {
  //     hideInMenu: true
  //   },
  //   component: () => import("@/views/error-page/500.vue")
  // },
  // {
  //   path: "/404",
  //   name: "error_404",
  //   meta: {
  //     hideInMenu: true
  //   },
  //   component: () => import("@/views/error-page/404.vue")
  // }
];